export default __webpack_public_path__ + "static/mobile_KV10-d844518850b755d8ddeec26e64771563.mp4";